// Keep the Brand Agent launcher anchored while retaining its native prompts and chat.
(() => {
  const styles = `
    [data-testid="entrypoint"] {
      position: fixed !important;
      inset: auto 12px calc(88px + env(safe-area-inset-bottom, 0px)) auto !important;
      margin: 0 !important;
      transform: none !important; translate: none !important;
      animation: none !important; transition: opacity .2s ease !important;
    }
    [data-testid="entrypoint"] > [role="button"] {
      width: 48px !important; height: 48px !important; box-sizing: border-box;
      transform: none !important; translate: none !important;
      animation: none !important; transition: none !important;
      touch-action: manipulation;
    }
    [data-testid="entrypoint"] > [role="button"] > .relative {
      padding: 0 !important; width: 44px; height: 44px;
    }
    [data-testid="entrypoint"] .size-11 { width: 44px; height: 44px; }
    /* Prompt text changes inside a separate bubble without moving the icon. */
    [data-testid="entrypoint"] .size-11 + div {
      position: absolute; right: 56px; top: 50%; transform: translateY(-50%);
      width: max-content; max-width: calc(100vw - 92px);
      padding: 10px 14px; border-radius: 20px;
      background: white; color: #20231d; box-shadow: 0 2px 12px #00000018;
    }
    :host([data-pindu-dialog-open]) [data-testid="entrypoint"] { visibility: hidden !important; }
    @media (max-width: 600px) {
      [data-testid="floating-view"] {
        inset: 8px !important; margin: 0 !important;
        width: calc(100% - 16px) !important; min-width: 0 !important;
        max-width: calc(100vw - 16px) !important;
        height: calc(100dvh - 16px) !important; max-height: calc(100dvh - 16px) !important;
        transform: none !important; border-radius: 16px !important;
      }
      [data-testid="floating-view"] :is(.genux-size, .chat-size) {
        width: 100% !important; min-width: 0 !important; max-width: 100% !important;
        box-sizing: border-box;
      }
      [data-testid="floating-view"] .composer-edge-gradient {
        position: absolute !important; width: 100% !important;
        bottom: 0 !important; padding-bottom: env(safe-area-inset-bottom, 0px);
      }
      [data-testid="floating-view"] .flex-1 { min-width: 0; }
      [data-testid="floating-view"] > div:first-child > div { padding: 12px !important; }
      /* The mobile panel already fills the screen; keep room for Close. */
      [data-testid="floating-view"] button[aria-label="Expand"] { display: none; }
      [data-testid="floating-view"] .chat-card [data-testid="image-card"] {
        width: 88px; height: 88px;
      }
      [data-testid="floating-view"] [data-component-type="SUGGESTION_CHIP"] {
        max-width: 100%; height: auto; min-height: 40px; white-space: normal;
      }
    }
  `;
  let scheduled = false;
  function update() {
    scheduled = false;
    const host = document.getElementById('ads-agent-host');
    const root = host?.shadowRoot;
    if (!root) return;
    if (!root.getElementById('pindu-launcher-style')) {
      const style = document.createElement('style');
      style.id = 'pindu-launcher-style'; style.textContent = styles; root.append(style);
    }
    host.toggleAttribute('data-pindu-dialog-open', !!document.querySelector('dialog[open], .menu-drawer-container[open]'));
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } }
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['open']});
  // The app may attach its shadow root after inserting the host.
  let attempts = 0;
  const timer = setInterval(() => { schedule(); if (document.getElementById('ads-agent-host')?.shadowRoot || ++attempts >= 60) clearInterval(timer); }, 1000);
  schedule();
})();
